import { html, nothing, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ref } from 'lit/directives/ref.js';
import { UIModalServiceModal } from '../../../../app/package/base/service/modals/modal-service';
import { type GameDetails, TileType } from '../../../base/package/api/package/gaming/gaming-domain';
import { I18n } from '../../../base/package/services/package/i18n/i18n.de';
import type { UIModal } from '../../ui-modal/ui-modal';
import '../../incentive/game-tile-deck/game-tile-deck';
import '../../incentive/badge/badge';
import styles from './ui-free-spin-logout-modal.css?inline';

const CName = 'ui-free-spin-logout-modal';

@customElement(CName)
export class UIFreeSpinLogoutModal extends UIModalServiceModal {
  static readonly styles = unsafeCSS(styles);

  @property({ type: Array }) games: GameDetails[] = [];
  @property({ type: Number }) freeSpinCount = 0;
  @property({ type: String }) bonusId = '';
  @property({ type: String }) expiresAt = '';

  public close() {
    this._modalRef.value?.close();
  }

  render() {
    const isFanned = this.games.length > 1;
    return html`
      <ui-modal
        ${ref(this._modalRef)}
        .isDismissible=${true}
        .onAction=${() => this._handlePlayNow()}
        .actionButtonLabel=${window.$app.$t.get(I18n.rewards.freeSpinLogout.action)}
        .onAltAction=${(e: UIModal) => this._handleLogout(e)}
        .altActionButtonVariant=${'secondary-outlined'}
        .altActionButtonLabel=${window.$app.$t.get(I18n.mod.account.logout.logout)}
        class="modal--centered modal--fancy-bg"
        style="--fancy-bg: url(${window.staticAssets.gamification?.incentiveBackground ?? ''}) center top / cover no-repeat; --fancy-bg-filter: blur(8px) brightness(0.6)"
      >
      <div slot="main" class="content">
        <div class="deck-container">
          <incentive-game-tile-deck
            class="deck"
            style="--deck-tile-count: ${this.games.length}"
            .games=${this.games}
            variant=${isFanned ? 'fanned-large' : 'default'}
            .tileType=${TileType.P4}
          ></incentive-game-tile-deck>
          <incentive-reward-badge
            class="badge"
            .value=${`${this.freeSpinCount} FS`}
            .size=${'md'}>
          </incentive-reward-badge>
        </div>
        <div class="title">
          ${window.$app.$t.get(I18n.rewards.freeSpinLogout.title)}
        </div>
        ${
          this.expiresAt
            ? html`<div class="expires-at-container"><incentive-badge class="expires-at" .variant=${'semi-transparent'}><span class="expires-at__label">${window.$app.$t.get(I18n.rewards.freeSpinLogout.expiresAtLabel)}</span>  ${this.expiresAt}</incentive-badge></div>`
            : nothing
        }
      </div>
      </ui-modal>
    `;
  }

  private _handlePlayNow() {
    this._modalRef.value?.close();

    if (this.games.length === 1) {
      window.$app.router.navigateToGame(true, this.games[0]!.id);
    } else if (this.bonusId) {
      window.$app.router.navigateToIncentiveReward(this.bonusId);
    } else {
      // Edge case
      window.$app.router.navigateToIncentive();
    }
  }

  private _handleLogout(modal: UIModal) {
    modal.close();
    window.$app.logout();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIFreeSpinLogoutModal;
  }
}
